import React, { useState } from 'react';
import {
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
  MotifButton,
  MotifIcon,
  MotifLabel,
  MotifFormField,
  MotifTextLink,
  MotifInput,
} from '@ey-xd/motif-react';
import { contentIcAddCircle24px, contentIcCreate24px } from '@ey-xd/motif-react/assets/icons';
import '@organisms/modals/styles/judgeModelStyles.css';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
  Active_Tab_Gcsp,
  All_Month_Data_State,
  Gcsp_Opp_View_State,
  Recoil_Gcsp_Quarter_State,
  System_Date_Time_State,
} from '@recoil/recoil';
import { formateTOV } from '@util/commonUtil';

const JudgeModal = ({ KeyName }) => {
  const [isModalVisible, setModalVisibility] = useState(false);
  const [isSaveDisabled, setIsSaveDisabled] = useState(false);
  const [value, setValue] = useState('');
  //Below Line direct-import-and-test-needed
  const [submittedValue, setSubmittedValue] = useState(''); // eslint-disable-line
  //Below Line direct-import-and-test-needed
  const [isEditMode, setIsEditMode] = useState(false); // eslint-disable-line
  const [gcspOppViewData, setGcspOppViewData] = useRecoilState(Gcsp_Opp_View_State);
  const [Your_Total_Commit, setYour_Total_Commit] = useState('TBD');
  const quarterData = useRecoilValue(Recoil_Gcsp_Quarter_State);
  const systemDateTime = useRecoilValue(System_Date_Time_State);
  const tabActive = useRecoilValue(Active_Tab_Gcsp);
  const [allMonthData, setAllMonthData] = useRecoilState(All_Month_Data_State);

  let PL_Committed_Value = 0;
  let Your_Judge = 0;

  if (
    allMonthData[tabActive].Total_Forecasted !== null &&
    allMonthData[tabActive].Your_Judge !== null &&
    allMonthData[tabActive].Total_Commit !== null
  ) {
    PL_Committed_Value = allMonthData[tabActive].Total_Forecasted.find(obj => KeyName in obj);
    PL_Committed_Value = PL_Committed_Value[KeyName];
    Your_Judge = allMonthData[tabActive].Your_Judge[0][KeyName];
  } else {
    PL_Committed_Value = gcspOppViewData.Total_Forecasted.find(obj => KeyName in obj);
    PL_Committed_Value = PL_Committed_Value[KeyName];
    Your_Judge = gcspOppViewData.Your_Judge[0][KeyName];
  }

  const TodaysDate = systemDateTime ? new Date(systemDateTime) : new Date();
  const personaStartDateCheck = quarterData ? new Date(quarterData.persona_startdate) : new Date();
  const personaCloseDateCheck = quarterData ? new Date(quarterData.persona_closedate) : new Date();
  const isReadOnly = localStorage.getItem('isReadOnly') === 'true';
  let IsSubmitDisabled = false;
  IsSubmitDisabled =
    isReadOnly ||
    !(TodaysDate >= personaStartDateCheck && TodaysDate <= personaCloseDateCheck) ||
    (localStorage.getItem('isSuperUser') == 'true' &&
      localStorage.getItem('targetUserEmail') !== 'null')
      ? true
      : false;

  const handleOpenModal = event => {
    event.preventDefault();
    if (value === '-') {
      setValue('');
    }
    // Validate retained value to set correct save button state
    if (value !== '' && value !== '-') {
      const numericValue = Number(value);
      const newTotalCommit = Number(PL_Committed_Value) + numericValue;
      setIsSaveDisabled(newTotalCommit < 0);
    } else {
      // Enable save button when input is empty or just '-' since saving 0 is a valid business case
      // Originally, setIsSaveDisabled(false) was inside the if (!IsSubmitDisabled) block at line 85,
      // which unconditionally enabled the save button regardless of retained value validation.
      // Moved here to ensure validation happens first - if retained value would make Total Commit negative,
      // save button stays disabled; otherwise it's enabled for empty input (allowing user to save 0).
      setIsSaveDisabled(false);
    }
    if (!IsSubmitDisabled) {
      setModalVisibility(true);
      setIsEditMode(false);
    }
  };

  const handleSubmit = () => {
    // setSubmittedValue(value);
    judgeValueCalculation();
    setModalVisibility(false);
  };

  const handleEdit = event => {
    event.preventDefault();
    if (!IsSubmitDisabled) {
      setModalVisibility(true);
      setIsEditMode(true);
      setValue(Your_Judge);
      setYour_Total_Commit(Number(PL_Committed_Value) + Number(Your_Judge));
      // Validate existing value to ensure save button state is correct
      const newTotalCommit = Number(PL_Committed_Value) + Number(Your_Judge);
      setIsSaveDisabled(newTotalCommit < 0);
    }
  };

  const judgeValueCalculation = () => {
    if (gcspOppViewData.length !== 0) {
      let Total_Commit = allMonthData[tabActive].Total_Commit;
      let Your_Judge = allMonthData[tabActive].Your_Judge;
      if (Your_Total_Commit !== 'TBD') {
        Total_Commit = allMonthData[tabActive].Total_Commit.map(data => ({
          ...data,
          [KeyName]: Your_Total_Commit,
        }));
      }
      if (value !== '-') {
        Your_Judge = allMonthData[tabActive].Your_Judge.map(data => ({
          ...data,
          [KeyName]: Number(value),
        }));
      }

      setGcspOppViewData({
        ...gcspOppViewData,
        Total_Commit: Total_Commit,
        Your_Judge: Your_Judge,
      });

      setAllMonthData({
        ...allMonthData,
        [tabActive]: {
          ...allMonthData[tabActive],
          Total_Commit: Total_Commit,
          Your_Judge: Your_Judge,
        },
      });
    }
  };

  return (
    <>
      {Your_Judge ? (
        <span
          style={{
            fontFamily: 'EYInterstate',
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '20px',
            letterSpacing: '0px',
            color: '#2E2E38',
          }}
        >
          <MotifTextLink
            variant="alt"
            href="#"
            onClick={handleEdit}
            disabled={IsSubmitDisabled}
            aria-label={`Edit Your Judge ${Your_Judge}`}
          >
            <MotifIcon src={contentIcCreate24px} />
            <span aria-hidden="true"> {Your_Judge ? formateTOV(Your_Judge) : ''}</span>
          </MotifTextLink>
        </span>
      ) : (
        <MotifTextLink variant="alt" href="#" onClick={handleOpenModal} disabled={IsSubmitDisabled}>
          <MotifIcon src={contentIcAddCircle24px} />
          Add Judge
        </MotifTextLink>
      )}
      <MotifModal
        show={isModalVisible}
        variant="alt"
        onClose={() => setModalVisibility(false)}
        className="modal-container"
        focusTrapOptions={{
          initialFocus: false,
        }}
      >
        {/* <MotifModalHeader>
          {isEditMode ? 'Add Judge: Assurance' : 'Add Judge: Assurance'}
        </MotifModalHeader> */}
        <MotifModalHeader className="modal-header" closeModalButton={true}>
          {KeyName.toLowerCase() === 'assurance'
            ? 'Judge Value: Assurance'
            : KeyName.toLowerCase() === 'consulting'
              ? 'Judge Value: Consulting'
              : KeyName.toLowerCase() === 'sat'
                ? 'Judge Value: SAT'
                : KeyName.toLowerCase() === 'tax'
                  ? 'Judge Value: Tax'
                  : KeyName.toLowerCase() === 'itts'
                    ? 'Judge Value: ITTS'
                    : KeyName.toLowerCase() === 'emiaacr'
                      ? 'Judge Value: EMEIA ACR'
                      : ''}
        </MotifModalHeader>
        <MotifModalBody className="custom-modal-body">
          <div className="row-layout">
            <div className="table-data1">
              <div className="text-value1">PL Committed Value</div>
            </div>
            <div className="table-data2">
              <div className="text-value2">
                {PL_Committed_Value ? formateTOV(PL_Committed_Value) : '$0'}
              </div>
            </div>
          </div>
          <div className="row-layout">
            <div className="table-data1">
              <div className="text-value1">Your Judge</div>
            </div>
            <MotifFormField className="input-area">
              {value === '' ? <MotifLabel className="text-label">Add Judge</MotifLabel> : null}
              <MotifInput
                className="input-value"
                value={value}
                onChange={event => {
                  const inputValue = event.target.value;
                  // Allow input if it's empty, a valid number, with two decimal points
                  // A max of 12 digits without the decimal points can be entered by user, including decimals it'd be 15 chars
                  if (/^-?\d{0,12}(\.\d{0,2})?$/.test(inputValue)) {
                    // If inputValue is just '-', set it to 0 when updating setYour_Total_Commit
                    const numericInputValue = inputValue === '-' ? 0 : +inputValue;
                    setValue(inputValue);
                    const newTotalCommit = Number(PL_Committed_Value) + Number(numericInputValue);
                    const shouldDisableSave = newTotalCommit < 0;
                    setIsSaveDisabled(shouldDisableSave);
                    setYour_Total_Commit(newTotalCommit);
                    setSubmittedValue(numericInputValue);
                  }
                }}
                required={true} // Add the required attribute
              />
            </MotifFormField>
          </div>
          <div className="row-layout">
            <div className="table-data1">
              <div className="text-value1">Your Total Commit</div>
            </div>
            <div className="table-data2">
              <div className="text-value2">
                {Your_Total_Commit !== 'TBD' ? formateTOV(Your_Total_Commit) : '$0'}
              </div>
            </div>
          </div>
        </MotifModalBody>
        <MotifModalFooter>
          <MotifButton type="button" onClick={handleSubmit} disabled={isSaveDisabled}>
            Save
          </MotifButton>
          <MotifButton variant="secondary" type="button" onClick={() => setModalVisibility(false)}>
            Cancel
          </MotifButton>
        </MotifModalFooter>
      </MotifModal>
    </>
  );
};

export default JudgeModal;
